// extracted by mini-css-extract-plugin
module.exports = {"twoColumnLayout":"TwoColumnLayout_twoColumnLayout__2H4nj"};